import React from 'react'
import { apiFetch } from '../../../fetchApi';

export const createEducation = ({ BeURL, education, setEducation, handleTopClear, candidateId, showAlert }) => {
    if (!BeURL || !education.length === 0) {
        alert("Please fill all required fields and check server URL")
    }

    apiFetch(`${BeURL}/candidate-education`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ education, candidateId }),
    })
        .then((res) => res.json())
        .then((data) => {

            showAlert(data.message);

            if (data.success) {
                setEducation(prev => [...prev, education[0]])
                handleTopClear()
                window.location.reload()
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in create a new education", err);

        });

}

